import { Plus } from 'lucide-react';

import { Button } from 'components/ui/button';
import { Switch } from 'components/ui/switch';
import { cn } from 'lib/utils';

const switchClassName =
  'h-5 w-9 border-transparent bg-grey-100 data-[state=checked]:bg-black-base dark:!bg-muted dark:data-[state=checked]:!bg-true-white [&_[data-state]]:size-4 [&_[data-state=checked]]:translate-x-[16px] [&_[data-state=unchecked]]:translate-x-0.5 [&>span]:!bg-true-white dark:[&>span]:!bg-true-white dark:data-[state=checked]:[&>span]:!bg-black-base';

const addButtonClassName =
  'h-[38px] shrink-0 gap-[6px] rounded-[62px] border border-grey-100 bg-grey-50 pl-[18px] pr-6 text-base font-medium leading-[1.2] text-[#3d3d3d] shadow-none hover:bg-[#f0f0f0] hover:text-[#3d3d3d] dark:!border-grey-100 dark:!bg-grey-50 dark:!text-[#3d3d3d] dark:hover:!bg-[#f0f0f0] dark:hover:!text-[#3d3d3d] [&_svg]:!size-6';

type AgentConfigSectionActionsProps = {
  addLabel: string;
  /** Shows the Add button. */
  onAdd?: () => void;
  isAddDisabled?: boolean;
  toggleLabel: string;
  checked?: boolean;
  /** Shows the on/off switch. */
  onCheckedChange?: (checked: boolean) => void;
  isToggleDisabled?: boolean;
  className?: string;
};

/** The Add button and on/off switch beside an agent configuration section title. */
export function AgentConfigSectionActions({
  addLabel,
  onAdd,
  isAddDisabled = false,
  toggleLabel,
  checked = false,
  onCheckedChange,
  isToggleDisabled = false,
  className,
}: AgentConfigSectionActionsProps) {
  return (
    <div className={cn('flex shrink-0 items-center gap-3', className)}>
      {onAdd ? (
        <Button
          type="button"
          variant="outline"
          className={addButtonClassName}
          onClick={onAdd}
          disabled={isAddDisabled}
        >
          <Plus className="size-6" strokeWidth={1.5} aria-hidden />
          {addLabel}
        </Button>
      ) : null}

      {onCheckedChange ? (
        <Switch
          checked={checked}
          disabled={isToggleDisabled}
          className={switchClassName}
          onCheckedChange={onCheckedChange}
          aria-label={toggleLabel}
        />
      ) : null}
    </div>
  );
}
